// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  Asset,
  serializeAsset,
  deserializeAsset,
} from "./types/channelState";

@jsonObject()
export default class GetGuardrails extends PerunMessage {
  @jsonMember({
    deserializer: (json: any) =>
      Array.isArray(json) ? json.map(deserializeAsset) : [],
    serializer: (assets: Asset[]) => assets.map(serializeAsset),
  })
  assets: Asset[];
  @jsonMember(String) hub: string;

  constructor(assets: Asset[], hubAddress: string) {
    super();
    this.assets = assets;
    this.hub = hubAddress;
  }

  messageType(): MessageType {
    return GetGuardrails;
  }

  messageTypeName(): MessageTypeName {
    return "GetGuardrails";
  }
}
